import swaggerClient from "../remote-client";
import Utils from "../Utils";

export default class AppointmentsManagementServiceImpl {
  fetchAppointments(officeId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentsOfficeWithOfficeId(
            {
              officeId: officeId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  fetchAppointmentsForBill(parameters) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getAppointmentsOfficeWithOfficeIdStateWithStatePast(
            parameters,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  fetchAppointmentsByIUP(parameters) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getAppointmentsOfficeWithOfficeIdIupWithIupCode(
            parameters,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  fetchAppointmentById(parameters) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getAppointmentsOfficeWithOfficeIdIdWithAppointmentId(
            parameters,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body.appointment;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  /**
   * Get member contact info
   * @param {*} appointmentId
   */
  callGetMemberContactInfo(appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getAppointmentWithAppointmentIdContactInfo(
            { appointmentId },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body.contactInfo;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  fetchRejectReasons(rejectReasonType) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityManagement.getRejectreasonWithRejectReasonType(
            { rejectReasonType },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  cancelAppointment(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdCancel(
            {
              id: appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  cancelConfirmAppointment(appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdCancelconfirm(
            {
              id: appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  verifyAppointmentDeliveryDate(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentsOfficeWithOfficeIdVerifyDeliveryDate(
            {
              officeId: payload.officeId
            },
            swaggerClient.buildRequest(payload.obj),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body?.checks;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  setAppointmentToDone(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdDone(
            { id: payload.id },
            swaggerClient.buildRequest({
              appointmentDeliveryDate: payload.deliveryDate
            }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  setAppointmentToAdministrativeCheckRequired(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdAdministrativeCheckRequired(
            { id: payload.id },
            swaggerClient.buildRequest(payload.obj),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  setAppointmentToNotDone(appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdNotdone(
            {
              id: appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  setAppointmentNoImpact(appointmentId) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdNoImpact(
            {
              id: appointmentId
            },
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  setAppointmentDate(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentSetDate(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(() => {})
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifyExpostAppointmentDate(id, dateAndTime) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdExpostModifyDate(
            {
              id
            },
            swaggerClient.buildRequest({ dateAndTime }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifySlotAppointmentDate(id, dateAndTime) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdSlotModifyDate(
            {
              id
            },
            swaggerClient.buildRequest({ dateAndTime }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifyTimeperiodAppointmentDate(id, dateAndTime) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithIdTimeperiodModifyDate(
            {
              id
            },
            swaggerClient.buildRequest({ dateAndTime }),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifySlotAppointmentService(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdSlotModifyService(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifyTimeperiodAppointmentService(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdTimeperiodModifyService(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifyExpostAppointmentService(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdExpostModifyService(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  modifyAppointmentAncillaries(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdModifyAncillaries(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({
            type: Utils.errorTypes.STATUS,
            reason
          });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  callModifyAppointmentDone(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdDoneModifyService(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  callModifyAppointmentInBillWithBillBeforeFinancial(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdInBillModifyService(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  callModifyAppointmentInBillWithBillAlreadyFinancial(appointmentId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentWithAppointmentIdInBillModifyServiceBillRectification(
            {
              appointmentId
            },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(response => {
        return response.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  callDownloadVoucherDocument(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getDocumentWithDocumentIdMemberWithMemberIdVoucher(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  callDownloadPrescriptionDocument(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityBillsManagement.getDocumentWithDocumentIdMemberWithMemberIdAppointmentWithAppointmentIdPrescription(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  callDownloadInvoiceDocument(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityBillsManagement.getDocumentWithDocumentIdMemberWithMemberIdAppointmentWithAppointmentIdInvoice(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  callDownloadFascicoloDocument(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityBillsManagement.getDocumentWithDocumentIdMemberWithMemberIdAppointmentWithAppointmentIdFascicolo(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  getAppointmentsCountByStates(officeId, payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentsCountOfficeWithOfficeId(
            { officeId },
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
        } else return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
      });
  }

  getAncillariesList(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getAncillariesOfficeWithOfficeIdServiceWithServiceId(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }
}
